export default __webpack_public_path__ + "static/roadx1-b6454f64f4184b06370370e3b886e53b.png";